import { IconProps } from '../icon';

export function FuseeIcon(props: IconProps) {
  return (
    <svg
      id="fusée"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="39.995"
      height="40"
      viewBox="0 0 39.995 40"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_2426"
            data-name="Rectangle 2426"
            width="39.995"
            height="40"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-3">
          <rect
            id="Rectangle_2415"
            data-name="Rectangle 2415"
            width="11.298"
            height="11.294"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-4">
          <rect
            id="Rectangle_2416"
            data-name="Rectangle 2416"
            width="10.875"
            height="12.967"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-5">
          <rect
            id="Rectangle_2417"
            data-name="Rectangle 2417"
            width="12.949"
            height="10.962"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-6">
          <rect
            id="Rectangle_2418"
            data-name="Rectangle 2418"
            width="9.307"
            height="9.347"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-7">
          <rect
            id="Rectangle_2419"
            data-name="Rectangle 2419"
            width="0.066"
            height="0.161"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-8">
          <rect
            id="Rectangle_2420"
            data-name="Rectangle 2420"
            width="0.134"
            height="0.106"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-9">
          <rect
            id="Rectangle_2421"
            data-name="Rectangle 2421"
            width="1.376"
            height="0.448"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-10">
          <rect
            id="Rectangle_2422"
            data-name="Rectangle 2422"
            width="1.195"
            height="1.254"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-11">
          <rect
            id="Rectangle_2423"
            data-name="Rectangle 2423"
            width="0.064"
            height="0.508"
            fill="none"
          />
        </clipPath>
        <clipPath id="clipPath-12">
          <rect
            id="Rectangle_2424"
            data-name="Rectangle 2424"
            width="13.544"
            height="13.618"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_11679" data-name="Groupe 11679" clipPath="url(#clipPath)">
        <g id="Groupe_11678" data-name="Groupe 11678">
          <g
            id="Groupe_11677"
            data-name="Groupe 11677"
            clipPath="url(#clipPath)"
          >
            <path
              id="Tracé_9407"
              data-name="Tracé 9407"
              d="M85.964,75.307c-.067.141-.133.278-.2.419-.067-.189.023-.319.2-.419"
              transform="translate(-72.351 -63.545)"
              fill="#2c87ca"
            />
            <path
              id="Tracé_9408"
              data-name="Tracé 9408"
              d="M122,113.1a1.272,1.272,0,0,1-.117.069c-.022-.028-.044-.056-.066-.083.061,0,.122.008.183.014"
              transform="translate(-102.788 -95.425)"
              fill="#2c87ca"
            />
            <path
              id="Tracé_9409"
              data-name="Tracé 9409"
              d="M142.962,135.048l0,.042a.27.27,0,0,0-.031-.014l.036-.028"
              transform="translate(-120.602 -113.955)"
              fill="#2c87ca"
            />
            <path
              id="Tracé_9410"
              data-name="Tracé 9410"
              d="M178.082,168.878c-.108.186-.248.278-.461.178l-.009,0a.194.194,0,0,0-.016-.031.364.364,0,0,1,.055.009c.145-.05.287-.1.431-.152"
              transform="translate(-149.857 -142.501)"
              fill="#2c87ca"
            />
            <g
              id="Groupe_11649"
              data-name="Groupe 11649"
              transform="translate(28.697)"
              opacity="0.4"
            >
              <g id="Groupe_11648" data-name="Groupe 11648">
                <g
                  id="Groupe_11647"
                  data-name="Groupe 11647"
                  clipPath="url(#clipPath-3)"
                >
                  <path
                    id="Tracé_9411"
                    data-name="Tracé 9411"
                    d="M193.888,11.294q-5.082-5.079-10.162-10.16a29.361,29.361,0,0,1,9.2-1.115C194.425.07,194.947.6,195,2.1a29.119,29.119,0,0,1-1.115,9.193"
                    transform="translate(-183.726 0)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_9412"
              data-name="Tracé 9412"
              d="M78.9,145.683l-.022.006s0,0,.006-.006l.011,0Z"
              transform="translate(-66.556 -122.924)"
              fill="#a3d5f5"
            />
            <path
              id="Tracé_9413"
              data-name="Tracé 9413"
              d="M134.385,200.458c.019.008.037.015.056.025l-.075.036a.346.346,0,0,1,.019-.061"
              transform="translate(-113.379 -169.148)"
              fill="#c1e2f8"
            />
            <path
              id="Tracé_9414"
              data-name="Tracé 9414"
              d="M140.706,195.161c.039-.023.077-.048.114-.073a.839.839,0,0,1-.078.248c-.009-.059-.022-.117-.036-.175"
              transform="translate(-118.729 -164.617)"
              fill="#c1e2f8"
            />
            <path
              id="Tracé_9415"
              data-name="Tracé 9415"
              d="M177.65,169.8l-.03.027-.009,0a.194.194,0,0,0-.016-.031.361.361,0,0,1,.055.009"
              transform="translate(-149.856 -143.268)"
              fill="#c1e2f8"
            />
            <g
              id="Groupe_11652"
              data-name="Groupe 11652"
              transform="translate(17.627 26.371)"
              opacity="0.6"
            >
              <g id="Groupe_11651" data-name="Groupe 11651">
                <g
                  id="Groupe_11650"
                  data-name="Groupe 11650"
                  clipPath="url(#clipPath-4)"
                >
                  <path
                    id="Tracé_9416"
                    data-name="Tracé 9416"
                    d="M123.718,170.7c-.03.853-.112,1.7-.137,1.826a13.026,13.026,0,0,1-1.261,3.507c-1.293,2.438-3.665,5.147-6.494,5.714a2.979,2.979,0,0,1-2.372-.55,1.329,1.329,0,0,1-.6-.956c-.014-.495.391-.882.69-1.277a3.726,3.726,0,0,0-.045-4.322,1.6,1.6,0,0,0,1.329-.147c.455-.234.923-.442,1.385-.659l.075-.036.951-.615a34.882,34.882,0,0,0,5.751-4.164l.03-.027.433-.152c.265-.091.3.885.265,1.857"
                    transform="translate(-112.853 -168.839)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_9417"
              data-name="Tracé 9417"
              d="M134.441,200.483l-.075.036a.346.346,0,0,1,.019-.061c.019.008.037.015.056.025"
              transform="translate(-113.379 -169.148)"
              fill="#a4d6f5"
            />
            <g
              id="Groupe_11655"
              data-name="Groupe 11655"
              transform="translate(0.664 11.402)"
              opacity="0.6"
            >
              <g id="Groupe_11654" data-name="Groupe 11654">
                <g
                  id="Groupe_11653"
                  data-name="Groupe 11653"
                  clipPath="url(#clipPath-5)"
                >
                  <path
                    id="Tracé_9418"
                    data-name="Tracé 9418"
                    d="M17.2,73.362c-.067.141-.133.278-.2.42a38.012,38.012,0,0,0-4.194,5.942.672.672,0,0,0-.328.411c.012.009.025.02.039.03a.333.333,0,0,1-.055.022c-.223.436-.458.867-.669,1.307-.276.575-.654,1.132-.4,1.824a3.748,3.748,0,0,0-4.312-.053,4.564,4.564,0,0,1-.872.612c-1.181.505-1.938-1.3-1.961-2.2-.065-2.608,2.377-4.926,4.332-6.306,2.216-1.563,5.4-2.831,8.141-2.209.176.041.362.019.475.2"
                    transform="translate(-4.253 -73.002)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_9419"
              data-name="Tracé 9419"
              d="M70.409,7.174a6.434,6.434,0,0,0-1.61.473c-.533.186-1.025.439-1.537.665a28.191,28.191,0,0,0-3.119,1.553,28.936,28.936,0,0,0-5.482,4.319,51.014,51.014,0,0,0-7.775,10.034c-.559.935-1.792,2.382-1.362,3.541l2.652,2.682.106.2c.915-1.109,1.938-2.143,2.943-3.157.54-.547,1.09-1.084,1.64-1.623a15.725,15.725,0,0,1,1.306-1.193c.083-.07.165-.141.247-.212A3.309,3.309,0,0,1,60.74,23.7q.091,0,.183.014A3.741,3.741,0,0,1,63.36,25.14c.013.017.025.033.036.05a4.032,4.032,0,0,1,.639,1.678c.016.086.027.175.037.266l0,.042a3.31,3.31,0,0,1-.781,2.148q-.171.211-.351.412c-.175.216-.362.426-.556.631C60.83,32,59.239,33.594,57.65,35.191c-.119.12-.241.241-.365.358l.017.017q1.342,1.326,2.683,2.651a1.6,1.6,0,0,0,1.329-.147c.455-.234.923-.442,1.386-.659a.348.348,0,0,1,.019-.061c.019.008.037.016.056.025l.951-.615c-.013-.083-.042-.127,0-.2.083.041.045.094.023.178a35.9,35.9,0,0,0,3.332-2.193c.608-.45,1.2-.918,1.795-1.387.7-.553,1.395-1.1,2.077-1.676,3.511-2.947,7.1-6.768,8.573-11.211a13,13,0,0,0,1.05-2.938Q75.49,12.255,70.409,7.174M74.3,18.405c0,.086-.009.17-.016.256-.014.167-.036.336-.064.508l-.01.028a8.293,8.293,0,0,1-.9,1.845c-.03.047-.058.1-.087.142a5.181,5.181,0,0,1-4.034,1.6c-.047,0-.1,0-.144-.006a6.444,6.444,0,0,1-1.376-.448.169.169,0,0,1-.024-.011q-.061-.026-.117-.056t-.117-.061c-.042-.022-.084-.044-.127-.069a4.461,4.461,0,0,1-.512-.336c-.045-.034-.091-.069-.134-.106s-.073-.059-.108-.09-.1-.086-.141-.13-.069-.066-.1-.1c0,0,0-.006-.008-.008-.034-.034-.067-.07-.1-.106a4.105,4.105,0,0,1-.6-.848c-.025-.044-.048-.087-.069-.131s-.044-.086-.064-.13-.044-.094-.062-.141-.045-.106-.066-.161-.049-.127-.069-.189a6.373,6.373,0,0,1-.289-1.268c0-.048,0-.1,0-.145a4.783,4.783,0,0,1,2.193-4.114s.008,0,.011-.008a4.564,4.564,0,0,1,5.079.136l.07.048.094.067A4.838,4.838,0,0,1,73.6,15.628l.073.117c.022.036.042.073.064.111.045.078.087.159.127.242a.015.015,0,0,1,0,.008c.039.083.075.166.109.25s.059.156.086.236c.012.033.022.066.033.1.015.052.03.1.044.154.011.037.02.077.03.116a.467.467,0,0,0,.012.05,4.386,4.386,0,0,1,.083.481,5.034,5.034,0,0,1,.033.914"
              transform="translate(-41.713 -6.04)"
              fill="#8fae0c"
            />
            <path
              id="Tracé_9420"
              data-name="Tracé 9420"
              d="M117.086,170.186c-.039.044-.077.086-.114.13a.512.512,0,0,1-.027-.119l.036-.014a.577.577,0,0,1,.1,0"
              transform="translate(-98.679 -143.601)"
              fill="#2964ad"
            />
            <path
              id="Tracé_9421"
              data-name="Tracé 9421"
              d="M134.385,200.458c.019.008.037.015.056.025l-.075.036a.346.346,0,0,1,.019-.061"
              transform="translate(-113.379 -169.148)"
              fill="#2964ad"
            />
            <path
              id="Tracé_9422"
              data-name="Tracé 9422"
              d="M140.82,195.088a.844.844,0,0,1-.078.248c-.009-.059-.022-.117-.036-.175.039-.023.076-.048.114-.073"
              transform="translate(-118.729 -164.617)"
              fill="#2964ad"
            />
            <path
              id="Tracé_9423"
              data-name="Tracé 9423"
              d="M56.891,118.7a.319.319,0,0,1-.055.022c0-.017.009-.034.016-.052.012.009.025.02.039.03"
              transform="translate(-47.959 -100.132)"
              fill="#2963ad"
            />
            <path
              id="Tracé_9424"
              data-name="Tracé 9424"
              d="M78.9,145.683l-.022.006s0,0,.006-.006l.011,0Z"
              transform="translate(-66.556 -122.924)"
              fill="#2963ad"
            />
            <path
              id="Tracé_9425"
              data-name="Tracé 9425"
              d="M85.086,138.51c0,.016-.008.031-.012.045a.5.5,0,0,1-.087-.019l.07-.069c.011.014.02.028.03.042"
              transform="translate(-71.712 -116.84)"
              fill="#2963ad"
            />
            <path
              id="Tracé_9426"
              data-name="Tracé 9426"
              d="M8.009,204.27c-1.95,1.916-3.867,3.87-5.8,5.8a2.3,2.3,0,0,1-.611.485,1.138,1.138,0,0,1-1.275-.324,1.122,1.122,0,0,1,.045-1.612q2.964-3.021,6-5.979a1.136,1.136,0,0,1,1.726-.034,1.116,1.116,0,0,1-.08,1.665"
              transform="translate(0 -170.639)"
              fill="#8fae0c"
            />
            <path
              id="Tracé_9427"
              data-name="Tracé 9427"
              d="M53.463,224.715a1.007,1.007,0,0,1-.3.7c-.573.6-1.142,1.206-1.756,1.76a1.153,1.153,0,0,1-1.64-1.615,20.853,20.853,0,0,1,1.818-1.807,1.079,1.079,0,0,1,1.307-.077,1.105,1.105,0,0,1,.565,1.034"
              transform="translate(-41.743 -188.59)"
              fill="#8fae0c"
            />
            <path
              id="Tracé_9428"
              data-name="Tracé 9428"
              d="M10.852,182.54a8.956,8.956,0,0,1-2.223,2.252,1.236,1.236,0,0,1-.406.131,1.254,1.254,0,0,1-1.076-.594,1,1,0,0,1,.058-1.237,22.787,22.787,0,0,1,1.988-1.973,1,1,0,0,1,1.36.094.989.989,0,0,1,.3,1.326"
              transform="translate(-5.875 -152.64)"
              fill="#8fae0c"
            />
            <g
              id="Groupe_11658"
              data-name="Groupe 11658"
              transform="translate(23.267 7.391)"
              opacity="0.3"
            >
              <g id="Groupe_11657" data-name="Groupe 11657">
                <g
                  id="Groupe_11656"
                  data-name="Groupe 11656"
                  clipPath="url(#clipPath-6)"
                >
                  <path
                    id="Tracé_9429"
                    data-name="Tracé 9429"
                    d="M158.186,53.044l-.009.028a8.286,8.286,0,0,1-.9,1.845c-.03.047-.058.1-.087.142a5.181,5.181,0,0,1-4.034,1.6c-.047,0-.1,0-.144-.006a4.143,4.143,0,0,1-1.26-.4,4.918,4.918,0,0,1-1.056-.618,4.439,4.439,0,0,1-1.4-1.9,4.734,4.734,0,0,1,1.6-5.544,4.655,4.655,0,0,1,2.15-.85,4.807,4.807,0,0,1,4.79,2.625,5.15,5.15,0,0,1,.353,3.071"
                    transform="translate(-148.965 -47.317)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_11661"
              data-name="Groupe 11661"
              transform="translate(23.605 13.807)"
              opacity="0.3"
            >
              <g id="Groupe_11660" data-name="Groupe 11660">
                <g
                  id="Groupe_11659"
                  data-name="Groupe 11659"
                  clipPath="url(#clipPath-7)"
                >
                  <path
                    id="Tracé_9430"
                    data-name="Tracé 9430"
                    d="M151.126,88.4c.02.055.042.108.066.161-.02-.047-.039-.092-.058-.139a.111.111,0,0,1-.008-.022"
                    transform="translate(-151.126 -88.398)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_11664"
              data-name="Groupe 11664"
              transform="translate(24.921 15.652)"
              opacity="0.3"
            >
              <g id="Groupe_11663" data-name="Groupe 11663">
                <g
                  id="Groupe_11662"
                  data-name="Groupe 11662"
                  clipPath="url(#clipPath-8)"
                >
                  <path
                    id="Tracé_9431"
                    data-name="Tracé 9431"
                    d="M159.555,100.208c.044.037.089.072.134.106l-.044-.033c-.031-.023-.061-.048-.091-.073"
                    transform="translate(-159.555 -100.208)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_11667"
              data-name="Groupe 11667"
              transform="translate(25.952 16.29)"
              opacity="0.3"
            >
              <g id="Groupe_11666" data-name="Groupe 11666">
                <g
                  id="Groupe_11665"
                  data-name="Groupe 11665"
                  clipPath="url(#clipPath-9)"
                >
                  <path
                    id="Tracé_9432"
                    data-name="Tracé 9432"
                    d="M166.156,104.3a6.444,6.444,0,0,0,1.376.448,4.151,4.151,0,0,1-1.26-.4c-.039-.017-.078-.034-.116-.053"
                    transform="translate(-166.156 -104.298)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_11670"
              data-name="Groupe 11670"
              transform="translate(30.696 8.334)"
              opacity="0.3"
            >
              <g id="Groupe_11669" data-name="Groupe 11669">
                <g
                  id="Groupe_11668"
                  data-name="Groupe 11668"
                  clipPath="url(#clipPath-10)"
                >
                  <path
                    id="Tracé_9433"
                    data-name="Tracé 9433"
                    d="M197.721,54.611a4.84,4.84,0,0,0-1.195-1.254,4.636,4.636,0,0,1,1.195,1.254"
                    transform="translate(-196.526 -53.357)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <g
              id="Groupe_11673"
              data-name="Groupe 11673"
              transform="translate(32.508 12.621)"
              opacity="0.3"
            >
              <g id="Groupe_11672" data-name="Groupe 11672">
                <g
                  id="Groupe_11671"
                  data-name="Groupe 11671"
                  clipPath="url(#clipPath-11)"
                >
                  <path
                    id="Tracé_9434"
                    data-name="Tracé 9434"
                    d="M208.19,80.807c-.014.17-.036.34-.064.508.028-.172.05-.34.064-.508"
                    transform="translate(-208.126 -80.807)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_9435"
              data-name="Tracé 9435"
              d="M85.086,138.51c0,.016-.008.031-.012.045a.5.5,0,0,1-.087-.019l.07-.069c.011.014.02.028.03.042"
              transform="translate(-71.712 -116.84)"
              fill="#2a71b9"
            />
            <path
              id="Tracé_9436"
              data-name="Tracé 9436"
              d="M122,113.1a1.272,1.272,0,0,1-.117.069c-.022-.028-.044-.056-.066-.083.061,0,.122.008.183.014"
              transform="translate(-102.788 -95.425)"
              fill="#2a71b9"
            />
            <path
              id="Tracé_9437"
              data-name="Tracé 9437"
              d="M117.086,170.186c-.039.044-.077.086-.114.13a.512.512,0,0,1-.027-.119l.036-.014a.577.577,0,0,1,.1,0"
              transform="translate(-98.679 -143.601)"
              fill="#2a72b9"
            />
            <path
              id="Tracé_9438"
              data-name="Tracé 9438"
              d="M142.962,135.048l0,.042a.27.27,0,0,0-.031-.014l.036-.028"
              transform="translate(-120.602 -113.955)"
              fill="#2a72b9"
            />
            <path
              id="Tracé_9439"
              data-name="Tracé 9439"
              d="M140.706,195.161c.039-.023.077-.048.114-.073a.839.839,0,0,1-.078.248c-.009-.059-.022-.117-.036-.175"
              transform="translate(-118.729 -164.617)"
              fill="#2a72b9"
            />
            <path
              id="Tracé_9440"
              data-name="Tracé 9440"
              d="M177.65,169.8l-.03.027-.009,0a.194.194,0,0,0-.016-.031.361.361,0,0,1,.055.009"
              transform="translate(-149.856 -143.268)"
              fill="#2a72b9"
            />
            <path
              id="Tracé_9441"
              data-name="Tracé 9441"
              d="M122,113.1a1.272,1.272,0,0,1-.117.069c-.022-.028-.044-.056-.066-.083.061,0,.122.008.183.014"
              transform="translate(-102.788 -95.425)"
              fill="#d0e9f9"
            />
            <path
              id="Tracé_9442"
              data-name="Tracé 9442"
              d="M142.962,135.048l0,.042a.27.27,0,0,0-.031-.014l.036-.028"
              transform="translate(-120.602 -113.955)"
              fill="#d0e9f9"
            />
            <path
              id="Tracé_9443"
              data-name="Tracé 9443"
              d="M78.9,145.683l-.022.006s0,0,.006-.006l.011,0Z"
              transform="translate(-66.556 -122.924)"
              fill="#c1e2f8"
            />
            <path
              id="Tracé_9444"
              data-name="Tracé 9444"
              d="M85.086,138.51c0,.016-.008.031-.012.045a.5.5,0,0,1-.087-.019l.07-.069c.011.014.02.028.03.042"
              transform="translate(-71.712 -116.84)"
              fill="#c1e2f8"
            />
            <path
              id="Tracé_9445"
              data-name="Tracé 9445"
              d="M117.086,170.186c-.039.044-.077.086-.114.13a.512.512,0,0,1-.027-.119l.036-.014a.577.577,0,0,1,.1,0"
              transform="translate(-98.679 -143.601)"
              fill="#c1e2f8"
            />
            <g
              id="Groupe_11676"
              data-name="Groupe 11676"
              transform="translate(8.79 17.683)"
              opacity="0.6"
            >
              <g id="Groupe_11675" data-name="Groupe 11675">
                <g
                  id="Groupe_11674"
                  data-name="Groupe 11674"
                  clipPath="url(#clipPath-12)"
                >
                  <path
                    id="Tracé_9446"
                    data-name="Tracé 9446"
                    d="M69.823,116.649a4.991,4.991,0,0,1-1.669,3.2c-1.549,1.635-3.141,3.228-4.729,4.824-1.32,1.328-3,2.707-5,1.919a3.491,3.491,0,0,1-2.149-3.087,3.293,3.293,0,0,1,.758-2.048,34.332,34.332,0,0,1,3.961-4.5c.541-.547,1.091-1.085,1.64-1.624.99-.971,2.134-2.131,3.621-2.133a3.623,3.623,0,0,1,3.279,2.1,3.209,3.209,0,0,1,.284,1.339"
                    transform="translate(-56.279 -113.21)"
                    fill="#8fae0c"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default FuseeIcon;
